import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
} from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

const DoughnutChart = ({ data, options, height, width = '100%' }) => {
    const chartHeight = height?.split('px')?.[0] ? parseInt(height?.split('px')?.[0]) - 20 : height;
    return (
        <div style={{ width, height: height, justifyContent: 'center', display: 'flex' }}>
            <Doughnut data={data} options={options} height={chartHeight} />
        </div>
    );
};

export default DoughnutChart;
